import React from 'react'
import './Voetnoot.css'
import bronnenlijst from "./../data/energietransitie/bronnenlijst"

import { Tooltip } from 'react-tippy';
import "react-tippy/dist/tippy.css";

function Voetnoot(props) {
  
  var tooltipTitel, titel, auteur, jaartal, url, pagina;
  
  bronnenlijst.bronnen.filter(bron => bron.id === props.id).map((filteredBron) => (    
    <>
      { auteur = filteredBron.auteur}
      { titel = filteredBron.titel ? `, ${filteredBron.titel}` : ''}
      { jaartal = filteredBron.jaar ? ` (${filteredBron.jaar})` : ''}
      { url = filteredBron.link ? `, ${filteredBron.link}` : ''}
      { pagina = filteredBron.pagina ? `, ${filteredBron.pagina}` : '.'}

      { tooltipTitel = `${auteur}<i>${titel}</i>${jaartal}${url}${pagina}`}
    </>
  ))
  
  return ( 
    <>
    { bronnenlijst.bronnen.filter(bron => bron.id === props.id).map((filteredBron) => (        
      <Tooltip title={tooltipTitel} duration="0">
        {filteredBron.link ? (
            <a href={filteredBron.link} target="_blank" rel="noreferrer" className='voetnoot' key={props.id} title="Klik om de link in een nieuw scherm te openen">
                [{props.id}]
            </a>
        ) : (
            <span className='voetnoot' key={props.id} >[{props.id}]</span>
        )}
      </Tooltip>      
    ))}
    
    </>
  )
}

export default Voetnoot